"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTemplates = exports.useExportDesignProviders = exports.useExportDataProviders = exports.useExportTypes = exports.useAllowdExportTypes = exports.useExportRequestStates = void 0;
const list_source_hook_1 = require("../../utils/list-source-hook");
const react_1 = require("react");
const export_context_1 = require("./export-context");
function useExportRequestStates() {
    return list_source_hook_1.useStaticListSource([
        { id: 'PENDING', name: 'Čekající' },
        { id: 'PROCESSING', name: 'Zpracováva se' },
        { id: 'PROCESSED', name: 'Ukončen' },
        { id: 'FAILED', name: 'Ukončen s chybu' },
    ]);
}
exports.useExportRequestStates = useExportRequestStates;
function useAllowdExportTypes(allowedTypes) {
    const items = [
        { id: 'DOCX', name: 'Dokument Word (docx)' },
        { id: 'XLSX', name: 'Sešit (xlsx)' },
        { id: 'PDF', name: 'Dokument PDF (pdf)' },
        { id: 'HTML', name: 'Stránka (html)' },
        { id: 'XML', name: 'Datový soubor (xml)' },
        { id: 'CSV', name: 'Datový soubor (csv)' },
    ];
    return list_source_hook_1.useStaticListSource(items.filter((item) => allowedTypes === null || allowedTypes === void 0 ? void 0 : allowedTypes.includes(item.id)));
}
exports.useAllowdExportTypes = useAllowdExportTypes;
function useExportTypes() {
    return list_source_hook_1.useStaticListSource([
        { id: 'DOCX', name: 'Dokument Word (docx)' },
        { id: 'XLSX', name: 'Sešit (xlsx)' },
        { id: 'PDF', name: 'Dokument PDF (pdf)' },
        { id: 'HTML', name: 'Stránka (html)' },
        { id: 'XML', name: 'Datový soubor (xml)' },
        { id: 'CSV', name: 'Datový soubor (csv)' },
    ]);
}
exports.useExportTypes = useExportTypes;
function useExportDataProviders() {
    return list_source_hook_1.useStaticListSource([
        { id: 'CONFIGURATION_PROVIDER', name: 'EAS Configuration data provider' },
        { id: 'NOOP_PROVIDER', name: 'No-op provider' },
        { id: 'PARAMS_PROVIDER', name: 'EAS Params provider' },
        { id: 'REPORTING_PROVIDER', name: 'EAS Reporting provider' },
        { id: 'SINGLE_ENTITY_PROVIDER', name: 'EAS Single entity provider' },
    ]);
}
exports.useExportDataProviders = useExportDataProviders;
function useExportDesignProviders() {
    return list_source_hook_1.useStaticListSource([
        { id: 'DYNAMIC_PROVIDER', name: 'Dynamic grid design provider' },
        { id: 'SIMPLE_PROVIDER', name: 'Simple design provider' },
    ]);
}
exports.useExportDesignProviders = useExportDesignProviders;
function useTemplates(tag) {
    const { url } = react_1.useContext(export_context_1.ExportContext);
    return list_source_hook_1.useListSource({
        url: `${url}/templates/tagged/${tag}`,
    });
}
exports.useTemplates = useTemplates;
//# sourceMappingURL=export-api.js.map